import { getConfig } from "../../../../hooks/use-config";
import { getLabel } from "../../../../hooks/use-labels";
import { PRICE_STEP, VOLUME_STEP } from "../../../../utils/constants";
import { hasAccessoryOptions } from "../../../Home/Components/SupplierFilters/filter-utils";

export const filterFormFields = ({
  fuelTypes,
  paramValues,
  accessoryProps,
  containerTypes,
  containerOptions,
}) => {
  const {
    maxVolume,
    minVolume,
    minPrice,
    maxPrice,
    fuelTypeId,
    containerTypeId,
    containerOptionId,
    containerMaterialId,
  } = paramValues;
  
  const minContainerVolume = +getConfig("minContainerVolume");
  const maxContainerVolume = +getConfig("maxContainerVolumeFilter");

  const minProductPrice = +getConfig("minProductPrice");
  const maxProductPrice = +getConfig("maxProductPrice");
  const maxRadius = +getConfig("maxRadiusInKM");

  const accessoryProducts = containerOptionId
    ? hasAccessoryOptions(containerOptions, containerOptionId)
    : false;

  const hiddenField = accessoryProducts || accessoryProps;
  const radius = paramValues["location.distanceMeters"];

  return {
    containerTypeId: {
      elementConfigs: {
        filterFieldLabel: getLabel("containerTypesLabel"),
        label: "",
        type: "checkbox",
        checkboxType: "group",
        options: containerTypes,
        className: "filter-checkbox",
      },
      hiddenField,
      value: containerTypeId || [],
    },

    fuelTypeId: {
      elementConfigs: {
        filterFieldLabel: getLabel("fuelTypesLabel"),
        label: "",
        type: "checkbox",
        checkboxType: "group",
        options: fuelTypes,
        className: "filter-checkbox",
      },
      hiddenField,
      value: fuelTypeId || [],
    },

    containerVolume: {
      elementConfigs: {
        filterFieldLabel: getLabel("volumeLabel"),
        label: "",
        type: "range-slider",
        placeholder: "Kg",
        required: true,
        minValue: minContainerVolume,
        maxRange: maxContainerVolume,
        variableRange: true,
        step: VOLUME_STEP,
      },
      hiddenField,
      value: [minVolume || minContainerVolume, maxVolume || maxContainerVolume],
    },

    ...(accessoryProps && {
      containerMaterialId: {
        elementConfigs: {
          filterFieldLabel: getLabel("chooseMaterialLabel"),
          label: "",
          type: "checkbox",
          checkboxType: "group",
          options: accessoryProps.materials,
          className: "filter-checkbox",
        },
        value: containerMaterialId || [],
      },

      radius: {
        elementConfigs: {
          filterFieldLabel: getLabel("radiusLabel"),
          label: "",
          type: "range-slider",
          placeholder: "KM",
          required: true,
          maxRange: maxRadius,
          minValue: 0,
        },
        value: [0, radius ? radius / 1000 : maxRadius],
      },
    }),
    price: {
      elementConfigs: {
        filterFieldLabel: getLabel("priceLabel"),
        label: "",
        type: "range-slider",
        placeholder: "GHS",
        required: true,
        minValue: minProductPrice,
        maxRange: maxProductPrice,
        variableRange: true,
        step: PRICE_STEP,
      },
      value: [minPrice || minProductPrice, maxPrice || maxProductPrice],
    },
  };
};
